import { AppKeys } from '../core/localization/const';

export enum SelectMode {
  All,
  Selected,
  Specific,
}

export enum Groups {
  DEVICES,
  ORDERS,
  DEVICETYPES,
  CUSTOMERS,
  NONE,
}

export const GroupNames = {
  [Groups.DEVICES]: AppKeys.Devices_Title,
  [Groups.ORDERS]: AppKeys.Orders_Title,
  [Groups.DEVICETYPES]: AppKeys.DTypes_Title,
  [Groups.CUSTOMERS]: AppKeys.Customers_Title,
  [Groups.NONE]: '',
};

export const GroupCriteriaDto = Object.freeze({
  OrderNumber: 0,
  DeviceName: 1,
  Active: 2,
  Status: 3,
  Availability: 4,
  ReadRights: 5,
  Customer: 6,
});

export const Pages = {
  [Groups.DEVICES]: '/Devices',
  [Groups.ORDERS]: '/Orders',
  [Groups.DEVICETYPES]: '/DeviceTypes',
  [Groups.CUSTOMERS]: '/Customers',
  [Groups.NONE]: '/',
};
